"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GBFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_80)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_80`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V23.9509H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.8737 16.1404L30 23.9509V21.7404L19.9158 16.1404H15.8737ZM8.05614 7.81053L-6 0V2.21053L4.08421 7.81053H8.05614Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.6351 16.1404L30 20.7509V16.1404H21.6351ZM15.8737 16.1404L30 23.9509V21.7404L19.9158 16.1404H15.8737ZM26.1825 23.9509L15.8667 18.2175V23.9509H26.1825ZM0.336843 16.1404L-6 19.6632V16.1404H0.336843ZM8.05614 17.1368V23.9579H-4.21053L8.05614 17.1368ZM2.29474 7.81053L-6 3.2V7.81053H2.29474ZM8.05614 7.81053L-6 0V2.21053L4.08421 7.81053H8.05614ZM-2.25263 0L8.06316 5.73333V0H-2.25263ZM23.593 7.81053L30 4.28772V7.81053H23.593ZM15.8737 6.81403V0H28.1474L15.8737 6.81403Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.2105 0H9.7193V9.73333H-6V14.2246H9.7193V23.9579H14.2105V14.2246H29.9298V9.73333H14.2105V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.8737 16.1404L30 23.9509V21.7404L19.9158 16.1404H15.8737ZM4.08421 16.1404L-6 21.7474V23.9579L8.05614 16.1404H4.08421ZM8.05614 7.81053L-6 0V2.21053L4.08421 7.81053H8.05614ZM19.8456 7.81053L30 2.21053V0L15.8737 7.81053H19.8456Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_80`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GBFlag };
